export const Variant = {
  Title: 'title',
  Title2: 'title2',
  Subtitle: 'subtitle',
  Subtitle2: 'subtitle2',
  Body: 'body',
  LabelSm: 'label-sm',
}
